import {
  PerspectiveCamera,
  Scene,
  SphereBufferGeometry,
  VideoTexture,
  MeshBasicMaterial,
  Mesh,
  WebGLRenderer,
  LinearFilter,
  Raycaster,
  Vector2,
  Group,
  MathUtils,
} from 'three';

import Keypoint from './Keypoint'
import loop from 'raf-loop'

// import * as dat from 'dat.gui';
// const gui = new dat.GUI();

import store from '@/store'
import emitter from '@/emitter'

import data from './data'

export default class Webgl {
  constructor($container, $video1, $video2) {
    this.onPointerMove = this.onPointerMove.bind(this)
    this.onPointerDown = this.onPointerDown.bind(this)
    this.onWindowClick = this.onWindowClick.bind(this)
    this.onPointerUp = this.onPointerUp.bind(this)
    this.onKeypointClose = this.onKeypointClose.bind(this)
    this.onRestart = this.onRestart.bind(this)
    this.update = this.update.bind(this)


    this.initControls()

    this.selectedObject = null

    this.container = $container;

    this.camera = new PerspectiveCamera( 60, window.innerWidth / window.innerHeight, 0.001, 1100 );
    this.camera.position.z = 10;
    this.scene = new Scene();
  
    const geometry = new SphereBufferGeometry( 500, 60, 40 );
    // invert the geometry on the x-axis so that all of the faces point inward
    geometry.scale( - 1, 1, 1 );
  
    $video1.play();
    // $video2.play();
  
    this.r1 = this.makeRoom($video1, geometry)
    this.r2 = this.makeRoom($video2, geometry)
    this.r2.visible = false

    this.currentRoom = 0
    
    this.renderer = new WebGLRenderer();
    this.renderer.setPixelRatio( window.devicePixelRatio );
    this.renderer.setSize( window.innerWidth, window.innerHeight );
    this.container.appendChild( this.renderer.domElement );
  
    // document.addEventListener( 'pointermove', this.onPointerMove );

    // this.controls = new OrbitControls(this.camera, {
    //   element: this.renderer.domElement,
    //   parent: window,
    //   distance: 0,
    //   phi: 1.3037144320,
    //   theta: 1.731802950291387,
    //   zoom: false,
    // })

    // this.controls.enablePan = false

    // this.controls.minDistance = -100;
    // this.controls.update();
    this.groupR1 = new Group();
    
    data.keypoints.r1.forEach((kp) => {
      const plane = new Keypoint(kp);
      this.groupR1.add(plane)
    })
    
    this.groupR2 = new Group();
    data.keypoints.r2.forEach((kp) => {
      const plane = new Keypoint(kp);
      this.groupR2.add(plane)
    })
    this.groupR2.visible = false
    this.groupR1.visible = false
    // this.groupR1.visible = false //@TODO

    this.scene.add(this.groupR1);
    this.scene.add(this.groupR2);

    // gui.add(this.groupR2.children[1].position, 'x', -500, 500)
    // gui.add(this.groupR2.children[1].position, 'y', -500, 500)
    // gui.add(this.groupR2.children[1].position, 'z', -500, 500)
    // gui.add(this.groupR2.children[1].rotation, 'x', -Math.PI * 2, Math.PI * 2)
    // gui.add(this.groupR2.children[1].rotation, 'y', -Math.PI * 2, Math.PI * 2)
    // gui.add(this.groupR2.children[1].rotation, 'z', -Math.PI * 2, Math.PI * 2)

    // const geometryz = new SphereGeometry( 5, 32, 32 );
    // const materialz = new MeshBasicMaterial( {color: 0xffff00} );
    // const sphere = new Mesh( geometryz, materialz );
    // this.scene.add( sphere );
		this.raycaster = new Raycaster();
		this.pointer = new Vector2();

    this.rooms = [
      {
        room: this.r1,
        hotspots: this.groupR1,
        video: $video1,
        audio: 'clairiere',
      },
      {
        room: this.r2,
        hotspots: this.groupR2,
        video: $video2,
        audio: 'bambous',
      }
    ]

    const engine = loop(this.update);
    engine.start();

    this.started()
    emitter.on('HELLO', this.onKeypointClose)
    emitter.on('RESTART', this.onRestart)
    emitter.on('READY', this.onWindowClick)
  }

  initControls() {
    this.isUserInteracting = false
    this.isUserClicking = false
    this.lon = 0
    this.lat = 0
    this.phi = 0
    this.theta = 0
    this.onPointerDownPointerX = 0
    this.onPointerDownPointerY = 0
    this.onPointerDownLon = 0
    this.onPointerDownLat = 0
    this.distance = 50
  }

  onWindowClick() {
    this.rooms[0].hotspots.visible = true
    if (this.rooms[0].video.paused) this.rooms[0].video.play()
  }

  onRestart(id) {
    if (id === 1) {
      this.rooms[1].hotspots.children.forEach(el => {
        el.reset()
      });
    } else if (id === 0) {
      this.rooms[0].hotspots.children.forEach(el => {
        el.reset()
      });
      this.rooms[1].hotspots.children.forEach(el => {
        el.reset()
      });
    }

    this.changeRoom(id)
    this.started()
  }

  makeRoom($video, geometry) {
    const texture = new VideoTexture( $video );
    const material = new MeshBasicMaterial( { map: texture } );
    texture.minFilter = texture.magFilter = LinearFilter;

    const mesh = new Mesh(geometry, material );
    this.scene.add(mesh);

    return mesh
  }

  changeRoom(id) {
    this.rooms.forEach(() => {
      this.rooms[this.currentRoom].hotspots.visible = false
      this.rooms[this.currentRoom].room.visible = false
      this.rooms[this.currentRoom].video.pause()
    })
    
    if (typeof(id) !== 'undefined') {
      this.currentRoom = id
    } else {
      if (this.currentRoom === 0) this.currentRoom = this.currentRoom === 0 ? 1 : 0
    }

    this.rooms[this.currentRoom].hotspots.visible = true
    this.rooms[this.currentRoom].room.visible = true
    if (this.rooms[this.currentRoom].video.paused) {
      this.rooms[this.currentRoom].video.play()
    }

    emitter.emit('SOUND:switch', this.rooms[this.currentRoom].audio)

    this.initControls()
  }

  onResize() {
    this.camera.aspect = window.innerWidth / window.innerHeight;
    this.camera.updateProjectionMatrix();
  
    this.renderer.setSize( window.innerWidth, window.innerHeight );
  }

  onKeypointClose() {
    if (store.state.user.progress === data.keypoints.r1.length) {
      this.changeRoom()
    } else {
      if (this.rooms[this.currentRoom].video.paused)
        this.rooms[this.currentRoom].video.play()
    }

    emitter.emit('SOUND', true)

    if (store.state.user.progress === data.keypoints.r1.length + data.keypoints.r2.length) {
      store.ended()
    } else {
      this.started()
    }
  }

  onPointerDown( event ) {
    this.isUserInteracting = true;
    this.isUserClicking = true;

    this.onPointerDownPointerX = event.clientX;
    this.onPointerDownPointerY = event.clientY;

    this.onPointerDownLon = this.lon;
    this.onPointerDownLat = this.lat;
  }

  onPointerMove( event ) {
    if (store.state.user.isOnKeypoint) {
      return
    }

    if (this.isUserInteracting === true) {
      this.lon = ( this.onPointerDownPointerX - event.clientX ) * 0.1 + this.onPointerDownLon;
      this.lat = ( this.onPointerDownPointerY - event.clientY ) * 0.1 + this.onPointerDownLat;
      this.isUserClicking = false
    }

    if ( this.selectedObject ) {
      this.selectedObject.hover(false)
      emitter.emit('KP:HOVER:OFF', this.selectedObject.uid)
      this.selectedObject = null;
    }

    this.pointer.x = ( event.clientX / window.innerWidth ) * 2 - 1;
    this.pointer.y = - ( event.clientY / window.innerHeight ) * 2 + 1;
    this.raycaster.setFromCamera( this.pointer, this.camera );
    const intersects = this.raycaster.intersectObject(this.rooms[this.currentRoom].hotspots, true);
    if (intersects.length > 0) {

      const res = intersects.filter( function ( res ) {
        return res && res.object;
      } )[ 0 ];

      if ( res && res.object ) {
        this.selectedObject = res.object.parent;
        this.selectedObject.hover(true)
        emitter.emit('KP:HOVER:ON', this.selectedObject.uid)
      }
    }
  }

  onPointerUp() {
    this.isUserInteracting = false;
    // e.preventDefault()
    if (!this.isUserClicking) return
    if (store.state.user.isOnKeypoint) return
    if (this.selectedObject) {
      if (this.selectedObject.uid !== 'next') {
        store.openkp(this.selectedObject.uid, this.selectedObject.hasBeenVisited)
        this.selectedObject.visited()
        emitter.emit('SOUND', false)

        this.paused()

        emitter.emit('KP:HOVER:OFF', this.selectedObject.uid)

      } else {
        this.changeRoom()
      }
      document.body.style.cursor = 'auto'
    }
  }

  destroy() {
    emitter.off('HELLO', this.onKeypointClose)
    emitter.off('RESTART', this.onRestart)
    window.removeEventListener('click', this.onWindowClick)
    this.paused()

    this.rooms.forEach((r) => {
      this.clearVideo(r.video)
    })

    this.cleaup(this.scene)
    this.renderer.renderLists.dispose()
  }

  clearVideo($video) {
    $video.pause();
    $video.removeAttribute('src'); // empty source
    const $srcs = [].slice.call($video.querySelectorAll('source'))
    $srcs.forEach($src => {
      $src.removeAttribute('src'); // empty source
    })
    $video.load();
  }

  cleaup(obj) {
    while(obj.children.length > 0){ 
      this.cleaup(obj.children[0]);
      obj.remove(obj.children[0]);
    }
    if(obj.geometry) obj.geometry.dispose();
  
    if(obj.material){ 
      //in case of map, bumpMap, normalMap, envMap ...
      Object.keys(obj.material).forEach(prop => {
        if(!obj.material[prop])
          return;
        if(obj.material[prop] !== null && typeof obj.material[prop].dispose === 'function')                                  
          obj.material[prop].dispose();                                                      
      })
      obj.material.dispose();
    }
  }

  paused() {
    this.container.removeEventListener( 'pointerdown', this.onPointerDown );
    this.container.removeEventListener( 'pointermove', this.onPointerMove );
    this.container.removeEventListener( 'pointerup', this.onPointerUp );
    this.rooms[this.currentRoom].video.pause()
  }

  started () {
    this.container.addEventListener( 'pointerdown', this.onPointerDown );
    this.container.addEventListener( 'pointermove', this.onPointerMove );
    this.container.addEventListener( 'pointerup', this.onPointerUp );
  }

  update() {
    if (!store.state.user.isOnKeypoint) {
      this.lat = Math.max( - 85, Math.min( 85, this.lat ) );
      this.phi = MathUtils.degToRad( 90 - this.lat );
      this.theta = MathUtils.degToRad( this.lon );
      if (this.lat === 0) {
        this.camera.position.x = this.distance * Math.sin( this.phi ) * Math.cos( this.theta );
        this.camera.position.y = this.distance * Math.cos( this.phi );
        this.camera.position.z = this.distance * Math.sin( this.phi ) * Math.sin( this.theta );
      } else {
        const coef = 0.3
        this.camera.position.x += (this.distance * Math.sin( this.phi ) * Math.cos( this.theta ) -  this.camera.position.x) * coef;
        this.camera.position.y += (this.distance * Math.cos( this.phi ) - this.camera.position.y) * coef;
        this.camera.position.z += ((this.distance * Math.sin( this.phi ) * Math.sin( this.theta )) - this.camera.position.z) * coef;
      }

      this.camera.lookAt( 0, 0, 0 );

      this.renderer.render( this.scene, this.camera );
    }
  }
}
